import { IdSeparator } from "@/constants/app";
import randomstring from "randomstring";
import { v4 as uuidv4 } from "uuid";

export function createCompositeId(idParts: string[]) {
  return idParts.join(IdSeparator);
}

/**
 * Generates a uuid v4 string
 * @returns uuid v4 string
 */
export function generateID() {
  // return uuidv4();
  return randomstring.generate(10);
}

export function generateLongId() {
  return randomstring.generate(20);
}

/**
 * Generates uuid of [0-9 a-z A-Z] characters, with legth 10 symbols, all lowercase
 * @returns string
 */
export function generateReadableId() {
  return randomstring.generate({
    length: 10,
    charset: "alphanumeric",
    capitalization: "uppercase",
  });
}
/**
 * Checks if a given object is empty like {}
 */
export function isEmptyObj(object: any): boolean {
  for (const objProp in object) {
    return false;
  }
  return true;
}

/**
 * Generates a uuid v4 string
 * @returns uuid v4 string
 */
export function generateUuidv4() {
  return uuidv4();
}
